jQuery(function($) {
	if ((!$body.hasClass('page-template-default') &&
		!$body.hasClass('page-template-page-rooms') &&
		!$body.hasClass('page-template-page-suites') &&
		!$body.hasClass('page-template-page-meetings') &&
		!$body.hasClass('page-template-page-club-access') &&
		!$body.hasClass('page-template-page-landing') &&
		!$body.hasClass('page-template-page-slider-grid') &&
		!$body.hasClass('page-template-page-faq') &&
		!$body.hasClass('page-template-page-contact') &&
		!$body.hasClass('page-template-page-dine') &&
		!$body.hasClass('page-template-page-awards') &&
		!$body.hasClass('page-template-page-listing')) ||
		$body.hasClass('page-template-page-specials') ||
		$body.hasClass('home')) {
		return;
	}

	$('.hero .slider').on('init', function(event){
		$('.hero .slider .slick-slide:not(.slick-active)').find('.content *').attr('tabindex', -1);

		$('.hero .slick-arrow').on('click', function() {
			setTimeout(function(){
				var currentSlideEl = $('.hero .slider .slick-active');
				currentSlideEl.find('.content *').first().focus();
			}, 100);
		});
	});

	var hero = $('.hero');
	var slider = hero.find('.slider');
	var slides = slider.find('.slide');
	var scrollDown = $('.scroll_down');
	var gdpr = $('#gdpr_message')
	initializeSlick(slider, {
		accessibility: true,
		dots: false,
		infinite: true,
		speed: 700,
		slidesToShow: 1,
		fade: true,
		pauseOnFocus: true,
		pauseOnHover: false,
		autoplay: false,
		nextArrow: '<button class="slider_arrow next_arrow white">Next</button>',
		prevArrow: '<button class="slider_arrow prev_arrow white">Previous</button>',
		arrows: hero.hasClass('single_panel_hero') ? true : false
	}, function(e) {
		var hero = slider.parents('.hero');
		slider.addClass('ready');
		hero.addClass('ready');

		if (hero.hasClass('single_panel_hero')) {
			slider.on('beforeChange', function() {
				hero.find('.darken').addClass('hide');
				hero.find('.darken_alternate').addClass('show');
				hero.find('.title').addClass('hide');
			});
		}
	});

	$('.hero .slider').on('afterChange', function() {
		setTimeout(function(){
			currentSlideEl = $('.hero .slider .slick-active');
			$('.hero .slider .slick-slide').find('.content *').attr('tabindex', -1);
			currentSlideEl.find('.content *').attr('tabindex', 0);
		}, 100);
	});


	$(window).on('panelsLoaded', function() {
		setTimeout(function() {
			if (window.currentSlidersState != 2) {
				slider.slick('slickPlay');
			} else {
				slider.data('autoplay', 1);
			}
		}, 100);
	});

	var pauseSlider = function() {
		slider.slick('slickPause');
	}

	slider.on('swipe', function() {
		pauseSlider();
	});

	slider.on('click', '.slider_arrow', pauseSlider);

	$(window).on('panelsLoaded', function() {
		setTimeout(function() {
			if (scrollDown) {
				scrollDown.css('display', 'flex');
				scrollDown.css('opacity', '.5');
			}
		}, 200);


		$(scrollDown).on("click", function(){
			var section = hero;
			var sectionPos = section.offset().top
			console.log(sectionPos)
			$('html, body').animate({
				scrollTop: section.offset().top+450
			}, 500);
		});
	});
});